import { REVISION_TYPES, RevisionType } from './types';

const REVISION_PREFIX = 'VALWIN_BO_REVISION';

export const REVISION_HEADERS: Record<RevisionType, string> = {
  main: 'PSI-Expected-Revision',
  group: 'PSI-GROUP-Expected-Revision',
  forms: 'X-PSI-FORM-Revision',
  configuration: 'X-PSI-CONF-Revision',
  career: 'X-PSI-CAREER-Revision',
};

export const getRevisionKey = (
  pharmacyId: string,
  type: RevisionType = 'main'
): string => {
  // Legacy key format (`VALWIN_BO_REVISION_CONFIGURATION_<pharmacyId>`), kept so stored revisions stay readable
  const infix = type === 'main' ? '' : `_${type.toUpperCase()}`;

  return `${REVISION_PREFIX}${infix}_${pharmacyId}`;
};

export const getStoredRevision = (
  pharmacyId: string,
  type: RevisionType = 'main'
): string | null => {
  const value = localStorage.getItem(getRevisionKey(pharmacyId, type));

  return value === 'null' ? null : value;
};

export const setStoredRevision = (
  pharmacyId: string,
  revision: string | null,
  type: RevisionType = 'main'
): void => {
  const key = getRevisionKey(pharmacyId, type);

  if (revision === null) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, revision);
  }
};

export const clearAllRevisions = (pharmacyId: string): void => {
  REVISION_TYPES.forEach((type) =>
    localStorage.removeItem(getRevisionKey(pharmacyId, type))
  );
};

export const clearAllTenantsRevisions = (): void => {
  const keys = Array.from({ length: localStorage.length }, (_, index) =>
    localStorage.key(index)
  );

  keys
    .filter((key): key is string => key?.startsWith(REVISION_PREFIX) ?? false)
    .forEach((key) => localStorage.removeItem(key));
};
